import { Link } from "react-router-dom";
import {
    Plus,
    Download,
    RefreshCw,
    ChevronRight,
    Clock3,
} from "lucide-react";

export default function Header() {
    return (
        <div className="mb-6">

            {/* Breadcrumb */}
            <div className="flex items-center text-sm text-gray-500 mb-2">

                <span>Inventory</span>

                <ChevronRight size={14} className="mx-2" />

                <span className="font-medium text-slate-700">
                    Beginning Balance
                </span>

            </div>

            {/* Header Card */}
            {/*<div className="bg-white border border-slate-200 rounded-xl px-6 py-5 shadow-sm">

                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">

                    <div>

                        <h1 className="text-3xl font-bold text-slate-800">
                            Beginning Balance
                        </h1>

                        <p className="text-gray-500 mt-1">
                            Manage warehouse opening stock (Beginning Balance)
                        </p>

                        <div className="flex items-center gap-2 mt-4 text-sm text-gray-500">

                            <Clock3 size={16} />

                            <span>
                                Last Sync :
                            </span>

                            <span className="font-medium text-slate-700">
                                15 Jul 2026 09:30 AM
                            </span>

                        </div>

                    </div>

                    <div className="flex flex-wrap gap-3">

                        <button
                            className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition"
                        >
                            <RefreshCw size={18} />

                            Refresh
                        </button>

                        <button
                            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                        >
                            <Download size={18} />

                            Export Excel
                        </button>

                        <Link
                            to="/beginning-balance/create"
                            className="flex items-center gap-2 px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                        >
                            <Plus size={18} />

                            New Beginning
                        </Link>

                    </div>

                </div>

            </div>*/}

        </div>
    );
}